import { Typography, Link } from '@mui/material';
import React from 'react';

const Copyright = () => (
  <>
    <Typography variant="body2" color="textSecondary" align="center">
      Copyright ©{' '}
      <Link
        color="inherit"
        target="_blank"
        href="https://tytotech.com.br/"
        style={{ textDecoration: 'none' }}
      >
        Tytotech
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
    <div style={{ padding: '5px', textAlign: 'center', marginTop: '25px' }}>
      <Typography variant="body2" align="center">
        v{process.env.REACT_APP_VERSION}
      </Typography>
    </div>
  </>
);
export default Copyright;
